webpackJsonp([109227225898571],{

/***/ 1532:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"title":"Donate"}}},"pathContext":{"id":"/opt/build/repo/src/pages/donate/index.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---donate-79671da9390902990fab.js